import { Model } from '@descomplica/dex-models';
import { WeekModel } from './WeekModel';
import { LAST_DISMISSED_WARNING_MESSAGE_WEEK_ID_KEY } from '../../helpers/postgradStudyPlanning/constants';

export interface StudyPlanningInfo {
  id: number;
  courseId: number;
  listsPerWeek: number;
  contractDate: string;
  contractExpirationDate: string;
  hasWeekToAnticipate: boolean;
  isActive: boolean;
  creationDate: string;
  expirationDate: string;
  shouldWarnOverdueUser: boolean;
}

export class StudyPlanningModel extends Model {
  id: number;

  courseId: number;

  listsPerWeek: number;

  contractDate: Date;

  contractExpirationDate: Date;

  hasWeekToAnticipate: boolean;

  isActive: boolean;

  creationDate: Date;

  expirationDate: Date;

  shouldWarnOverdueUser: boolean;

  constructor(studyPlanning: StudyPlanningInfo, getters: any) {
    super(getters);

    this.id = studyPlanning.id;
    this.courseId = studyPlanning.courseId;
    this.listsPerWeek = studyPlanning.listsPerWeek;
    this.contractDate = new Date(studyPlanning.contractDate);
    this.contractExpirationDate = new Date(studyPlanning.contractExpirationDate);
    this.hasWeekToAnticipate = studyPlanning.hasWeekToAnticipate;
    this.isActive = studyPlanning.isActive;
    this.creationDate = new Date(studyPlanning.creationDate);
    this.expirationDate = new Date(studyPlanning.expirationDate);
    this.shouldWarnOverdueUser = studyPlanning.shouldWarnOverdueUser;
  }

  get currentWeek(): WeekModel | null {
    if (!this.getters || !this.getters.studyPlanningWeek) {
      return null;
    }

    return this.getters.studyPlanningWeek;
  }

  get anticipatedWeeks(): WeekModel[] | null {
    return this.getters?.studyPlanningAnticipatedWeeks || null;
  }

  get shouldShowWarningMessage(): boolean {
    if (!this.shouldWarnOverdueUser) return false;

    const lastDismissedWarningMessageWeekId = Number(
      localStorage.getItem(LAST_DISMISSED_WARNING_MESSAGE_WEEK_ID_KEY),
    );
    if (!lastDismissedWarningMessageWeekId) return true;

    return lastDismissedWarningMessageWeekId !== this.currentWeek?.id;
  }

  dismissWarningMessage(): void {
    const currentWeekId = this.currentWeek?.id;

    if (!currentWeekId) return;

    localStorage.setItem(LAST_DISMISSED_WARNING_MESSAGE_WEEK_ID_KEY, currentWeekId.toString());
  }
}
